import { CARD_SIZES } from '../components'
import cardBackImg from '../../assets/images/cards/card-back.webp'

type DeckPileProps = {
  deckSize: number
  totalSize: number
}

export function DeckPile({ deckSize, totalSize }: DeckPileProps) {
  return (
    <div
      data-deck-pile
      className="absolute bottom-4 right-4 z-10 flex flex-col items-center gap-1"
      style={{ animation: 'fade-in 400ms ease-out' }}
    >
      <div className="relative" style={{ width: CARD_SIZES.sm.width + 4, height: CARD_SIZES.sm.height + 4 }}>
        {[2, 1, 0].map(offset => (
          <img
            key={offset}
            src={cardBackImg}
            alt="deck"
            className="absolute rounded-[10px]"
            style={{
              width: CARD_SIZES.sm.width,
              height: CARD_SIZES.sm.height,
              top: offset * 2,
              left: offset * 2,
              opacity: deckSize > offset ? 0.9 - offset * 0.15 : 0.15,
              boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
            }}
          />
        ))}
      </div>
      <div className="text-[10px] font-mono font-bold" style={{ color: 'rgba(180,220,190,0.5)' }}>
        {deckSize}/{totalSize}
      </div>
    </div>
  )
}
